<template>
    <div>        
        <div class="field-container">
            <div class="field quarter">
                <label for="" class="checkbox">
                    <input type="checkbox" :checked="attack.isAttack" @change="updateIsAttack">
                    Is Attack?
                </label>
            </div>      
            <div class="field quarter" v-if="attack.isAttack">
                <label for="" class="label">Attack Type</label>
                <div class="select">
                    <select name="" id="" :value="attack.type" @change="updateAttackType">
                        <option value="single">Single Attack</option>
                        <option value="multiple">Multiple Attacks</option>
                        <option value="area">Area Attack</option>
                    </select>
                </div>                    
            </div>      
        </div>
        <attack-primary v-if="attack.isAttack" />
        <attack-secondary v-if="attack.isAttack && attack.type == 'multiple'" />
        <attack-tertiary v-if="attack.isAttack && attack.type == 'multiple'" />
        <hr v-if="attack.isAttack" />
        <div class="field-container" v-if="attack.isAttack">
            <div class="field third">
                <label for="" class="label">First Failed Save</label>                
                <textarea name="" id="" cols="30" rows="3" class="textarea" :value="attack.failedSaves.first" @input="updateFirstFailedSave"></textarea>
            </div>
            <div class="field third">
                <label for="" class="label">Second Failed Save</label>                
                <textarea name="" id="" cols="30" rows="3" class="textarea" :value="attack.failedSaves.second" @input="updateSecondFailedSave"></textarea>
            </div>
            <div class="field third">
                <label for="" class="label">Third Failed Save</label>                
                <textarea name="" id="" cols="30" rows="3" class="textarea" :value="attack.failedSaves.third" @input="updateThirdFailedSave"></textarea>
            </div>
        </div>
    </div>        
</template>

<script>
import { mapState } from 'vuex';

import AttackTabPrimary from './tab-parts/AttackTabPrimary.vue';
import AttackTabSecondary from './tab-parts/AttackTabSecondary.vue';
import AttackTabTertiary from './tab-parts/AttackTabTertiary.vue';

export default {  
    props: {
        
    },
    components: {
        'attack-primary': AttackTabPrimary,
        'attack-secondary': AttackTabSecondary,
        'attack-tertiary': AttackTabTertiary,
    },
    data: function() {
        return {
            
        };
    },
    computed: {
        ...mapState({
            attack: state => state.attack,
            damage: state => state.damage,
        }),        
    },
    methods: {  
        updateIsAttack(e) {
            this.$store.commit('attack/setIsAttack', e.target.checked);
        },
        updateAttackType(e) {            
            this.$store.commit('attack/setType', e.target.value);            
        },
        updateFirstFailedSave(e) {
            this.$store.commit('attack/setFirstFailedSave', e.target.value);
        },
        updateSecondFailedSave(e) {
            this.$store.commit('attack/setSecondFailedSave', e.target.value);
        },
        updateThirdFailedSave(e) {
            this.$store.commit('attack/setThirdFailedSave', e.target.value);
        },                                
    },
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style>
    .field-container h2 {
        width: calc(100% - 2rem);
        margin: 0 1rem 1rem;
        font-weight: bold;
        font-size: 1.2rem;
    }
</style>
